export default __webpack_public_path__ + "static/media/brand-6.3074173b.png";